export class Approval {
    ruleMnemonic: string
    user: string
    comment: string
    timestamp: string
}
